function Loader() {
    return (
        <div className="loader">
            <img src={require("../../images/loader.gif").default} />

        </div>
    )
}
export default Loader;